
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';




const pagesRoutes: Routes = [


    {
        path: ''
        , component: AppComponent
        , children: [
    
            {
                path: 'modulo02'
                , loadChildren: './modulo02/modulo02.module#Modulo02Module'
            }
            ,
            {
                path: 'configuracion'
                , loadChildren: './configuracion/configuracion.module#ConfiguracionModule'
            },
            {
                path: 'planificacion'
                , loadChildren: './planificacion/planificacion.module#PlanificacionModule'
            },
            {
                path: 'aprobar-planificacion'
                , loadChildren: './aprobar-planificacion/aprobar-planificacion.module#AprobarPlanificacionModule'
            },            
            {
                path: 'servicio'
                , loadChildren: './servicio-catering/servicio-catering.module#ServicioCateringModule'
            },
            {
                path: 'produccion'
                , loadChildren: './produccion/produccion.module#ProduccionModule'
            },
        ]
    }



];


export const PAGES_ROUTES = RouterModule.forChild(pagesRoutes);
